import React, { useState, useEffect } from "react";
import { Table, Modal, Spinner, Alert, Form } from "react-bootstrap";
import { useAlert } from "react-alert";
import { baseUrl } from "../../../../services/config";
import { useSelector } from "react-redux";

export default function PromoteStudentModal({
  show,
  onHide,
  students,
  reload,
}) {
  console.log(students);
  const alert = useAlert();
  // configgration
  const authtoken = localStorage.getItem("userToken");
  const user = useSelector((state) => state.user.user);
  //arrays
  const [allsessions, setallsessions] = useState([]);
  const [campuses, setallcampuses] = useState(user.campuses || []);
  const [allcampus_classes, setallcampus_classes] = useState([]);
  const [allcampus_classe_sections, setallcampus_classe_sections] = useState(
    []
  );
  const [educationType, setEducationType] = useState(1);
  //strings
  const [selectedcampus, setselectedcampus] = useState("");
  const [allCampusSections, setallCampusSections] = useState([]);
  const [selectedclass, setselectedclass] = useState("");
  const [selectedsection, setselectedsection] = useState("");
  const [currentsession, setcurrentsession] = useState("");
  //booleans
  const [loader, setloader] = useState(false);

  const [campusCourseData, setCampusCourseData] = useState([]);
  const [courseClassData, setCourseClassData] = useState([]);
  const [classSectionData, setClassSectionData] = useState([]);

  const [campusId, setCampusId] = useState("");
  const [courseId, setCourseId] = useState("");
  const [classId, setClassId] = useState("");
  const [sectionId, setSectionId] = useState("");

  useEffect(() => {
    // getAllCampus();
    getAllSessions();
  }, []);

  //functions

  const getAllSessions = () => {
    fetch(`${baseUrl}/session`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        setallsessions(data.payload);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const onCampusChange = (id) => {
    setCampusId(id);
    getCampusCourses(id);
  };

  const getCampusCourses = (id) => {
    if (id == "") {
      return alert.error("Please Select Campus");
    }
    fetch(`${baseUrl}/campus-all-courses/${id}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => {
        res.json().then((data) => {
          setCampusCourseData(data.payload);
        });
      })
      .catch((err) => {
        alert.error(err);
      });
  };

  const onCourseChange = (id) => {
    setCourseId(id);
    getCourseClasses(id);
  };

  const getCourseClasses = (id) => {
    if (id == "") {
      return alert.error("Please Select Course");
    }
    fetch(`${baseUrl}/course-all-classes/${id}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => {
        res.json().then((data) => {
          setCourseClassData(data.payload);
        });
      })
      .catch((err) => {
        alert.error(err);
      });
  };

  const onClassChange = (id) => {
    setClassId(id);
    getSectionsList(id);
  };

  const getSectionsList = (id) => {
    if (id == "" || campusId == "" || courseId == "") {
      alert.error("Please Select Campus / Course/ Class");
      return;
    }
    fetch(`${baseUrl}/class-section/${campusId}/${courseId}/${id}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => {
        res.json().then((data) => {
          setClassSectionData(data.payload);
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const passOutStudent = () => {
    let selected_students = students.map((item, index) => String(item.id));
    console.log(selected_students, "student ids");
    setloader(true);
    let data = {
      student_ids: selected_students,
    };
    fetch(`${baseUrl}/student_pass_out `, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authtoken}`,
      },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((data) => {
        setloader(false);
        if (data.metadata) {
          if (data.metadata.success) {
            reload(campusId, courseId, classId, sectionId, currentsession);
            alert.success("Successfully Pass Out");
          } else {
            alert.error("Error Occured");
          }
        } else {
          alert.error("Error Occured");
        }

        onHide(false);
      })
      .catch((err) => {
        setloader(false);
        alert.show("Error Occured");
        console.log(err);
      });
  };

  const promoteStudents = () => {
    if (campusId == "") {
      alert.error("Campus is Required");
      return;
    }
    if (courseId == "") {
      alert.error("Course is Required");
      return;
    }
    if (classId == "") {
      alert.error("Class is Required");
      return;
    }
    if (sectionId == "") {
      alert.error("Section is Required");
      return;
    }

    let selected_students = students.map((item, index) => String(item.id));

    setloader(true);
    let data = {
      campus_id: campusId,
      course_id: courseId,
      student_class_id: classId,
      global_section_id: sectionId,
      year_id: currentsession,
      student_ids: selected_students,
    };
    fetch(`${baseUrl}/student_jump`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authtoken}`,
      },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((data) => {
        setloader(false);
        if (data.metadata) {
          if (data.metadata.success) {
            reload(campusId, courseId, classId, sectionId, currentsession);
            alert.success("Successfully Promoted");
          } else {
            alert.error("Error Occured");
          }
        } else {
          alert.error("Error Occured");
        }

        onHide(false);
      })
      .catch((err) => {
        setloader(false);
        alert.show("Error Occured");
        console.log(err);
      });
  };

  return (
    <div>
      <Modal size="lg" show={show}>
        <Modal.Header className="modal_header_style" closeButton>
          <Modal.Title
            className="Modal_Heading_font"
            id="contained-modal-title-vcenter"
          >
            Promote Students
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="form-group col-md-6 row">
            <label>
              <b>
                Select Session <span style={{ color: "red" }}>*</span>
              </b>
            </label>
            <select
              onChange={(e) => setcurrentsession(e.target.value)}
              className="form-select form-control"
              style={{ height: 40 }}
              value={currentsession}
              aria-label="Default select example"
            >
              <option value="">Select Session</option>
              {allsessions.map((session, index) => (
                <option key={index} value={session.id}>
                  {session.year}
                </option>
              ))}
            </select>
          </div>
          {currentsession != "" ? (
            <>
              <form className="form-card">
                <div className="row">
                  <div className="col-md-6">
                    <label>
                      <b>Select Campus </b>{" "}
                      <span style={{ color: "red" }}>*</span>
                    </label>
                    <select
                      onChange={(e) => onCampusChange(e.target.value)}
                      className="form-select form-control"
                      style={{ backgroundColor: "white", height: 40 }}
                      value={campusId}
                      aria-label="Default select example"
                    >
                      <option value="">Select Campus</option>
                      {campuses.map((campus, index) => (
                        <option key={index} value={campus.id}>
                          {campus.name}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="col-md-6">
                    <label>
                      <b>Select Course </b>{" "}
                      <span style={{ color: "red" }}>*</span>
                    </label>
                    <select
                      className="form-select form-control"
                      name="course_id"
                      value={courseId}
                      onChange={(e) => onCourseChange(e.target.value)}
                      style={{ backgroundColor: "white", height: 40 }}
                      aria-label="Default select example"
                    >
                      <option value="">Select Course</option>
                      {campusCourseData.map((item, index) => (
                        <option key={index} value={item.course?.id}>
                          {item.course?.name}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="col-md-6 mt-5">
                    <label>
                      <b>Select Class </b>{" "}
                      <span style={{ color: "red" }}>*</span>
                    </label>
                    <select
                      className="form-select form-control"
                      name="class_id"
                      value={classId}
                      onChange={(e) => onClassChange(e.target.value)}
                      style={{ backgroundColor: "white", height: 40 }}
                      aria-label="Default select example"
                    >
                      <option value="">Select Class</option>
                      {courseClassData.map((item, index) => (
                        <option key={index} value={item.class?.id}>
                          {item.class?.name}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="col-md-6 mt-5">
                    <label>
                      <b>Select Section </b>{" "}
                      <span style={{ color: "red" }}>*</span>
                    </label>
                    <select
                      className="form-select form-control"
                      name="section_id"
                      value={sectionId}
                      onChange={(e) => setSectionId(e.target.value)}
                      style={{ backgroundColor: "white" }}
                      aria-label="Default select example"
                    >
                      <option value="">Select Section</option>
                      {classSectionData.map((item, index) => (
                        <option key={index} value={item.section?.id}>
                          {item.section?.name}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              </form>
            </>
          ) : null}
        </Modal.Body>

        <Modal.Footer>
          {currentsession != "" ? (
            <>
              {loader ? (
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "flex-end",
                    padding: "15px",
                  }}
                >
                  {" "}
                  <span className="spinner-border"></span>{" "}
                </div>
              ) : (
                <>
                  <button
                    onClick={promoteStudents}
                    className="btn btn-success button_blue"
                  >
                    Promote
                  </button>
                  <button
                    onClick={passOutStudent}
                    className="btn btn-success button_blue"
                  >
                    Pass Out
                  </button>
                </>
              )}
            </>
          ) : null}
          <button
            onClick={() => {
              //cencelModal()
              onHide(false);
            }}
            className="btn btn-danger btn_width"
          >
            Cancel
          </button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}
